import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,[_c(VListItemIcon,[_c(VIcon,{attrs:{"color":"primary"}},[_vm._v("mdi-office-building")])],1),_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v("Empresas asociadas")]),_c(VListItemSubtitle,[_c('i',[_vm._v("No hay empresas asociadas")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }